var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#42a816"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09354 12.329L6.00834 10.2416C5.77599 10.0089 5.40661 10.0089 5.17426 10.2416C4.94191 10.4742 4.94191 10.8439 5.17426 11.0765L7.67054 13.5755C7.90289 13.8082 8.27822 13.8082 8.51058 13.5755L14.8257 7.25944C15.0581 7.02684 15.0581 6.65706 14.8257 6.42445C14.5934 6.19185 14.224 6.19185 13.9917 6.42445L8.09354 12.329Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0f9e56f6654d0a683fd349ce4559c4c6.svg";
export { ForwardRef as ReactComponent };